import React from 'react'
import { Route } from 'react-router-dom'

import ImageEditScreen from './ImageEditScreen'
import AssetLibraryScreen from './AssetLibraryScreen'

const AssetLibrary = () => (
  <div>
    <Route strict exact path="/assetlibrary/" component={AssetLibraryScreen} />
    <Route
      exact
      strict
      path="/assetlibrary/edit/:mediaId/"
      component={ImageEditScreen}
    />
  </div>
)

export default AssetLibrary



// WEBPACK FOOTER //
// ./src/AssetLibrary/index.js